import styled from 'styled-components/macro';

const Textarea = styled.textarea<{
  minWidth?: string;
  height?: string;
  minHeight?: string;
}>`
  min-width: ${({ minWidth }) => minWidth ?? '400px'};
  color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey9};
  width: 100%;
  min-height: ${({ minHeight }) => minHeight ?? '100px'};
  border-radius: ${({ theme }) => theme.borderRadiusPalette.textArea};
  resize: none;
  border: 1px solid
    ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.grey.grey5)};
  padding-left: 5px;
  font-family: ${({ theme }) => theme.fontFamily};
  ${({ height }) => height && `height: ${height};`}
  &:focus {
    outline: 0;
    border: 1px solid ${({ theme }) => theme.colorPalette.turquoise.normal};
  }
  background-color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : 'inherit')};
  &:focus {
    border-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.light : theme.colorPalette.turquoise.normal};
  }
  &:disabled {
    border: ${({ theme }) => (theme.colorPalette.isDarkMode ? 'none' : `1px solid ${theme.colorPalette.grey.grey5}`)};
    background-color: ${({ theme }) => theme.colorPalette.grey.grey1};
    color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.black : theme.colorPalette.grey.grey7)};
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.grey.grey3}!important;
    opacity: 0.7;
  }
`;

export default Textarea;
